<template lang="pug">
SideOverlaySlot(
  :isOpen="isOpen",
  :title="overlayTitle",
  @closeOverlay="closeOverlay"
)
  template(#contentTop)
    section.patient-section
        .patient-section__top
          p.bold Patient: {{ getUserFormatted(patientAppointment.patient) }}
          p
            span.bold {{ getDateFromUnixFormatted(patientAppointment.scheduledAt) }}&nbsp; 
            span  {{ getTimeFromUnixFormatted(patientAppointment.scheduledAt) }} 
          p with {{ getDoctorFormatted(patientAppointment.schedule.doctor) }}
          

    .info-pair
      .label Notes (Required)
      textarea(style="height: 383px;", v-model="noteText")
    
  template(#footer)
    .flex.flex--space-between
      BaseBtn.x-lg.red-outline(
        @click.prevent="closeOverlay"
      ) GO BACK
      BaseBtn.x-lg.green(
        type="submit",
        form="refferal-info"
        :disabled = "!noteText"
        @click.prevent="cancelAppointment"
      ) YES, CONTINUE
</template>

<script>
import { defineComponent } from "vue";
import SideOverlaySlot from "@/components/overlays/SideOverlaySlot.vue";
import { mapGetters } from "vuex";

import { patchPatientReferralById } from "@/api/patientReferral";

import { createPatientAppointmentNote } from "@/api/notifications.ts";
import { createToast } from "mosha-vue-toastify";

import { apiStatus, apiStatusComputedFactory } from "@/api";
const { IDLE, PENDING, SUCCESS, ERROR } = apiStatus;

import {
  getUserFormatted,
  getDateFromUnixFormatted,
  getTimeFromUnixFormatted,
  getDoctorFormatted,
} from "@/helpers";

export default defineComponent({
  components: { SideOverlaySlot },
  emits: ["closeCancelAppointmentOverlay", "closeCancelWithAppointmentOverlay"],

  props: {
    isOpen: {
      type: Boolean,
      required: true,
    },
    overlayTitle: {
      type: String,
      required: true,
    },
    patientAppointment: {
      required: false,
      type: Object,
    },
  },
  computed: {
    ...mapGetters(["getUserId", "getUserRoleContext"]),
  },
  data() {
    return {
      noteText: null,
      createPatientReferralNoteStatus: IDLE,
      patchPatientReferralByIdStatus: IDLE,
    };
  },
  methods: {
    getUserFormatted,
    getDateFromUnixFormatted,
    getTimeFromUnixFormatted,
    getDoctorFormatted,
    async createPatientReferralNote() {
      this.createPatientReferralNoteStatus = PENDING;
      try {
        let origin = "Community";
        let destination = "Clinic";

        if (this.getUserRoleContext.clinicHealthSystem) {
          origin = "Clinic";
          destination = "Community";
        }

        const res = await createPatientAppointmentNote({
          idEntity: this.patientAppointment.id,
          entityType: "referral",
          createdBy: this.getUserId,
          note: {
            content: this.noteText,
            stage: this.patientAppointment.stage,
            type: "Cancelled",
            origin: origin,
            destination: destination,
          },
        });
        this.noteText = "";
        this.createPatientReferralNoteStatus = SUCCESS;
      } catch (err) {
        this.createPatientReferralNoteStatus = ERROR;
        console.error(err);
      }
    },
    async patchPatientReferralById() {
      this.patchPatientReferralByIdStatus = PENDING;
      try {
        const res = await patchPatientReferralById(this.patientAppointment.id, {
          id: this.patientAppointment.id,
          idSchedule: this.patientAppointment.idSchedule,
          scheduledAt: this.patientAppointment.scheduledAt,
          stage: "ARCHIVES",
          status: "Cancelled",
          visitStatus: "CANCELED",
        });
        this.patchPatientReferralByIdStatus = SUCCESS;
        createToast("Referral was cancelled.", {
          timeout: 4000,
          type: "success",
          position: "bottom-right",
        });
      } catch (err) {
        this.patchPatientReferralByIdStatus = ERROR;
        console.error(err);
      }
    },
    closeOverlay() {
      this.$emit("closeCancelAppointmentOverlay");
    },
    cancelAppointment() {
      this.patchPatientReferralById().then(() => {
        this.createPatientReferralNote();
        this.$emit("closeCancelWithAppointmentOverlay");
      });
    },
  },
});
</script>

<style scoped lang="scss">
.info-pair {
  margin-top: 10px;
  .label {
    margin-bottom: 11px;
  }
}
body .patient-section {
  margin-top: 32px;
}
.small {
  font-size: 14px;
}
.patient-section {
  position: relative;
  z-index: 1;
  margin-bottom: 31px;
  padding: 15px 24px 15px;
  background-color: $primaryBgBlue;
  color: $primaryLightBlue;
  &__top {
    margin-bottom: 8px;
    p {
      margin: 0;
      font-size: 21px;
      line-height: 1.67;
      color: #019bdf;
    }
  }
}
form#refferal-info {
  margin: 12px 0 20px;
  .columns {
    margin-bottom: 0px;
    .column {
      padding-bottom: 0px;
    }
  }
}
.overlay-show-success {
  p {
    margin: 41px 0 60px;
  }
}
</style>
